import { AxiosResponse } from 'axios';
import { api } from '../../../lib';
import { PriceArchitectureUploadResponse } from './types';

const UPLOAD_ENDPOINT = '/price-architecture/upload';

export const uploadPriceArchitecture = (file: File): Promise<AxiosResponse<PriceArchitectureUploadResponse>> => {
  const formData = new FormData();
  formData.append('file', file);

  return api({
    url: UPLOAD_ENDPOINT,
    method: 'POST',
    expectToken: true,
    data: formData,
  });
};

export const PRICE_ARCHITECTURE_TEMPLATE_URL =
  'https://infoprice-prd-repository.s3.us-east-1.amazonaws.com/ipa/file-architecture/Template+Arquitetura+simplificada+v2.xlsx';

export const downloadPriceArchitectureTemplate = (): void => {
  const link = document.createElement('a');

  link.href = PRICE_ARCHITECTURE_TEMPLATE_URL;
  link.download = 'Template Arquitetura simplificada v2.xlsx';
  link.rel = 'noopener';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
